var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.data.class,on:{"click":_vm.event}},[_vm._v(" "+_vm._s(_vm.data.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }